


























































/* eslint-disable @typescript-eslint/camelcase */
import Vue from 'vue'

const STATUS_LABELS: Record<string, string> = {
  created: 'Cree',
  enqueued: 'En file d\'attente',
  sent_to_provider: 'Envoye au fournisseur',
  provider_pending: 'En attente fournisseur',
  provider_success: 'Succes fournisseur',
  provider_failed: 'Echec fournisseur',
  check_exhausted: 'Verifications epuisees'
}

const SOURCE_LABELS: Record<string, string> = {
  system: 'Systeme',
  webhook: 'Webhook',
  status_poll: 'Verification auto',
  manual_check: 'Verification manuelle',
  sandbox: 'Sandbox'
}

const DOT_COLORS: Record<string, string> = {
  created: '#6b7280',
  enqueued: '#6366f1',
  sent_to_provider: '#2563eb',
  provider_pending: '#d97706',
  provider_success: '#16a34a',
  provider_failed: '#dc2626',
  check_exhausted: '#ea580c'
}

const BADGE_STYLES: Record<string, Record<string, string>> = {
  created: { backgroundColor: '#e5e7eb', color: '#1f2937' },
  enqueued: { backgroundColor: '#e0e7ff', color: '#3730a3' },
  sent_to_provider: { backgroundColor: '#dbeafe', color: '#1e40af' },
  provider_pending: { backgroundColor: '#fef3c7', color: '#92400e' },
  provider_success: { backgroundColor: '#dcfce7', color: '#166534' },
  provider_failed: { backgroundColor: '#fee2e2', color: '#991b1b' },
  check_exhausted: { backgroundColor: '#ffedd5', color: '#9a3412' }
}

export default Vue.extend({
  props: {
    history: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    statusLabel(status: string): string {
      return STATUS_LABELS[status] || status
    },

    sourceLabel(source: string): string {
      return SOURCE_LABELS[source] || source
    },

    formatDate(timestamp: string): string {
      if (!timestamp) return ''
      const d = new Date(timestamp)
      return d.toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    },

    dotColorStyle(status: string): string {
      return DOT_COLORS[status] || '#9ca3af'
    },

    badgeStyle(status: string): Record<string, string> {
      return BADGE_STYLES[status] || { backgroundColor: '#e5e7eb', color: '#1f2937' }
    }
  }
})
